import React, { useEffect, useMemo, useState } from 'react';

import { useAccess } from '../auth/AccessContext.jsx';
import { StepUpCancelled, createStepUpController } from './controller.js';
import StepUpDialog from './StepUpDialog.jsx';

export { StepUpCancelled };

/**
 * const { withStepUp, stepUpDialog } = useStepUp();
 *
 *   const { batch, upload } = await withStepUp('INTAKE_UPLOAD', params,
 *     (stepUp) => api.intake.upload({ ...params, stepUp }));
 *
 *   await withStepUp('INTAKE_ACCEPT', { batchId, sha256, summarySha256 },
 *     (stepUp) => api.intake.accept(batchId, { sha256, summarySha256, stepUp }));
 *
 * Render {stepUpDialog} once in the screen. withStepUp rejects with
 * StepUpCancelled when the person closes the dialog - catch it and do nothing.
 */
export function useStepUp() {
    const { api } = useAccess();
    const controller = useMemo(() => createStepUpController({ start: api.stepUp.start }), [api]);
    const [state, setState] = useState(controller.state());

    useEffect(() => controller.subscribe(setState), [controller]);
    useEffect(() => () => controller.cancel(), [controller]);

    return {
        withStepUp: (actionType, params, submit) => controller.begin(actionType, params, submit),
        stepUpDialog: React.createElement(StepUpDialog, {
            state,
            onCode: (code) => controller.enter(code),
            onRenew: () => controller.renew(),
            onCancel: () => controller.cancel()
        })
    };
}
